import { Component, OnInit, ViewChild } from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable } from 'rxjs';
import { map, timestamp } from 'rxjs/operators';
import { LogsData } from 'src/app/model/LogsData';
import { BackOffServiceService } from 'src/app/services/back-off-service.service';
import { environment } from 'src/environments/environment';
import * as Parse from 'parse';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgbdModalContent } from '../alert-component';
// import { element } from '@angular/core/src/render3';

export interface FoodPlanData {
  food: string;
  foodPlanType: string;
  mobilePlan: string;
  weekly: string;
  days: string[];
  id: string;
}

export interface ActivityPlanData {
  activity: string;
  minutes: string;
  date: string;
  id: string;
}

export interface Section {
  name: string;
  updated: Date;
}

@Component({
  selector: 'app-plans-checklist',
  templateUrl: './plans-checklist.component.html',
  styleUrls: ['./plans-checklist.component.css']
})
export class PlansChecklistComponent implements OnInit {
  foodPlans: FoodPlanData[] = [];
  activityPlans: ActivityPlanData[] = [];
  isHandset$: Observable<boolean> = this.breakpointObserver.observe(Breakpoints.Handset)
  .pipe(
    map(result => result.matches)
  );

  constructor(
    private _bkoffService: BackOffServiceService,
    private breakpointObserver: BreakpointObserver,
    private modalService: NgbModal
  ) {
    Parse.initialize(environment.PARSE_APP_ID, environment.PARSE_JS_KEY);
    (Parse as any).serverURL = environment.serverURL;
  }

  ngOnInit() {
    this.pullFoodPlans();
    this.pullActivityPlans();
    this._bkoffService.getisDone().then((res) => {
      if (res[2]) {
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.title = 'First time in checklist!'
        modalRef.componentInstance.name = 'Here you can see your ongoing action plans.' +
          ' You can check plans as completed, partially completed, or not completed by clicking the corresponding faces. View checked plans in histories.';
        this._bkoffService.setIsFirstChecklist();
      }
    })
  }

  pullFoodPlans() {
    this.foodPlans = [];

    this._bkoffService.getOngoingFoodPlanHistory().then((res) => {
      res.forEach(element => {
        var trimmedDays = [];
        for (var d in element.days) {
          var s = element.days[d].split(" ");
          if (s[0].substr(0, 1) === "0") {
            trimmedDays.push(" " + s[0].substr(1));
          } else {
            trimmedDays.push(" " + s[0]);
          }
        }

        var mobilePlan = (element.foodplan.split(" "))[0];

        this.foodPlans.push({
          food: element.plannedFood,
          foodPlanType: element.foodplan,
          mobilePlan: mobilePlan,
          weekly: element.plannedTimes,
          days: trimmedDays,
          id: element.foodPlanId});
      });  
    });
  }

  pullActivityPlans() {
    this.activityPlans = [];

    this._bkoffService.getOngoingActivityPlanHistory().then((res) => {
      console.log(res);
      res.forEach(element => {
        this.activityPlans.push({
          activity: element.planactivity,
          minutes: element.planminutes,
          date: element.activitydays,
          id: element.activityPlanId
        })
      })
    })
  }

  makeFoodCompleted(id: string) {
    this._bkoffService.updateFoodPlanStatus("completed", id);
    this.foodPlans = this.foodPlans.filter(plan => plan.id != id);
  }

  makeFoodPartial(id: string) {
    this._bkoffService.updateFoodPlanStatus("partially completed", id);
    this.foodPlans = this.foodPlans.filter(plan => plan.id != id);
  }

  makeFoodUncompleted(id: string) {
    this._bkoffService.updateFoodPlanStatus("uncompleted", id);
    this.foodPlans = this.foodPlans.filter(plan => plan.id != id);
  }

  makeActivityCompleted(id: string) {
    this._bkoffService.updateActivityPlanStatus("completed", id);
    this.activityPlans = this.activityPlans.filter(plan => plan.id != id);
  }

  makeActivityPartial(id: string) {
    this._bkoffService.updateActivityPlanStatus("partially completed", id);
    this.activityPlans = this.activityPlans.filter(plan => plan.id != id);
  }

  makeActivityUncompleted(id: string) {
    this._bkoffService.updateActivityPlanStatus("not completed", id);
    this.activityPlans = this.activityPlans.filter(plan => plan.id != id);
  }

}
